import { FIREBASE_DEFAULT_FIRESTORE, FIREBASE_FIRESTORE, DEFAULT_DB_AVAILABLE } from "../Firebase";
import { User } from "firebase/auth";
import { doc, getDoc } from "firebase/firestore";
import { getRemoteEnv } from "../config/remoteEnv";

class UserService {

    public static GetUserRoles: any = async (user: User) => {
        try {
            const appId      = getRemoteEnv().appId;
            const db         = (await DEFAULT_DB_AVAILABLE()) ? FIREBASE_DEFAULT_FIRESTORE() : FIREBASE_FIRESTORE();
            const userDocRef = doc(db, "users", user.email || user.uid);
            const userDocSnap = await getDoc(userDocRef);
        
            if (userDocSnap.exists()) {
                const userData = userDocSnap.data();
                const appData  = userData?.[appId];
                console.log("user app data: ", appData);
                return appData || {};
            } else {
                console.log("No such document!");
                return {};
            }
        } catch (error) {
            console.error("Error fetching user document:", error);
            return {};
        }
    };
}

export default UserService;